import type { User } from '~/api/types/Authentication'

export default function () {
  const config = useRuntimeConfig()
  return useState<User | null>(config.public.api.userStateKey, () => null)
}
